import { createFileRoute, notFound } from "@tanstack/react-router"

// Unknown path under a country code. The router rewrites region-less requests
// to /us/... internally (see router.tsx `rewrite`), so this is the route that
// actually catches /terms, /hours and every other bad URL a customer or crawler
// tries. The router's defaultNotFoundComponent renders the 404 page.
export const Route = createFileRoute("/$countryCode/$")({
  loader: () => {
    throw notFound()
  },
})
